module.exports = __webpack_public_path__ + "static/media/branched.c2a56b5f.fbx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/branched.fbx
// module id = 181
// module chunks = 0